import {SET_RESOURCE_LINK} from '../constants/actionTypes';
import initialState from './initialState';
import _ from "lodash";

export default function resourceLinkReducer(state = initialState.resourceLink, action) {
  switch (action.type) {
    case SET_RESOURCE_LINK:
      return _.get(action, 'resourceLink', null);
    default:
      return state;
  }
}


